export const ACTION = '/catalog/GetAssociatedProducts';

export const rt = '{9E124193-8F2D-47A7-A6BD-166F216C1846}';
